import { FC, useState } from 'react';

import { BUTTON_TYPES } from '@savgroup-front-common/constants/shared';
import { LogoutIcon } from '@savgroup-front-common/core/protons/icons';

import { $LogoutButton } from './LogoutButton.styles';

interface LogoutButtonProps {
  onLogout: () => Promise<void>;
}

export const LogoutButton: FC<LogoutButtonProps> = ({ onLogout }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    await onLogout();
  };

  return (
    <$LogoutButton
      type={BUTTON_TYPES.BUTTON}
      onClick={handleClick}
      disabled={isLoading}
    >
      <LogoutIcon size="24px" />
    </$LogoutButton>
  );
};
